import { render } from "./TabListByName.vue?vue&type=template&id=d95a6fb0&scoped=true"
import script from "./TabListByName.vue?vue&type=script&lang=js"
export * from "./TabListByName.vue?vue&type=script&lang=js"

import "@/assets/scss/results/listByDate.scss?vue&type=style&index=0&id=d95a6fb0&scoped=true&lang=scss"

import exportComponent from "/Users/thanhnguyen/Desktop/ThanhNguyen/projects/public_html/numbers-betting-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d95a6fb0"]])

export default __exports__